import {
  ActionButtonProps,
  Box,
  BoxProps,
  Button,
  ColorOptions,
  convertHexToRGBA,
  Form,
  ModalDialogNew,
  ModBox,
  required,
  Spacer,
  SpacerNew,
  Text,
  TextInput,
  TextProps,
} from '@jfs/ui-new'
import { useInterval } from '@jfs/utils'
import { CommonActions, useNavigation, useRoute } from '@react-navigation/core'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { Dimensions, FlatList, InteractionManager, Keyboard, ScrollView, ViewStyle } from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { titleCase } from '../../../comps/CustomHeader/headerFunctionHelpers'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'
import { LottieLoader } from '../../../comps/LottieLoader'
import { HeaderLeft } from '../../../comps/MobileCustomHeader/HeaderLeft'
import { SvgImage } from '../../../comps/SvgImage'
import { TextInputWithLabelOnBorder } from '../../../comps/TextInputWithLabelOnBorder'
import { ToastPosition, ToastType } from '../../../comps/Toast'
import { RootStore, useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { Colors, getFromStore, isOsMobile, mobileNumber, storeData } from '../../../util/util'
import { PoweredBy } from '../Footer/PoweredBy'
import { Logo } from '../Logo'
import { BillItem } from './BillItem'
import { InfoText } from './InfoText'
import { ModeOfPayment } from './ModeOfPayment'

interface ExtraInfos {
  id?: number | string
  name?: string
  value?: string
}
export interface ExtraInfoProps {
  name: string
  value: string | undefined | null
}

export const TRANSACTION_PENDING = 'PENDING_P'

const height = Dimensions.get('screen').height

const BillFetch: FC = () => {
  const { getOperator, txnData, setMessage, createOrder, checkPaymentStatus, updateTransaction, status, redirectToPg } =
    useStores((root) => ({
      getOperator: root.billPayments?.getOperator,
      txnData: root.billPayments?.transaction,
      setMessage: root.response.setMessage,
      createOrder: root.billPayments?.createOrderApi,
      checkPaymentStatus: root.billPayments?.checkPaymentStatusApi,
      updateTransaction: root.billPayments?.updateBillfetchMetaData,
      status: root.billPayments.transaction.status,
      redirectToPg: root.billPayments.redirectToPg,
    }))
  const navigation = useNavigation()
  const params: any = useRoute().params ?? {}
  const mobileNumberRef = useRef<any>(null)
  const formRef = useRef(null)

  navigation.setOptions({
    gestureEnabled: true,
    headerLeft: () => <HeaderLeft />,
    headerStyle: { borderBottomColor: 'rgba(0,0,0,0)' },
    headerTintColor: '#fff',
    headerBackVisible: true,
    headerTransparent: true,
    title: titleCase(params?.title ?? ''),
    headerTitleStyle: {
      fontSize: 18,
      fontFamily: 'JioType-Bold',
    },
  })

  const [createOrderApi, { state: createOrderLoading, data: createOrderData }] = useLazyApiData(createOrder)
  const [redirectToPgView, { state: pgTxnState, data: pgTxnData }] = useLazyApiData(redirectToPg)
  const [checkPaymentStatusApi, { state: paymentStatusState, data: paymentStatusData }] =
    useLazyApiData(checkPaymentStatus)
  const txnMetaData = txnData?.txnMetaData
  const bill = txnMetaData?.bill
  const billAmount = parseFloat(bill?.amount ?? 0)
  const operator = getOperator()
  const partialPaymentAllow = operator?.partialPaymentAllow
  const partialPaymentType = operator?.partialPaymentType
  const [amount, setAmount]: any = useState(bill?.amount ?? 0)
  const [showModal, setShowModal] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [txnCheckStatus, setTxnCheckStatus] = useState('')
  const [pgPaymentSuccess, setPgPaymentSuccess] = useState(false)
  const [isRedirectingToPg, setIsRedirectingToPg] = useState(false)
  const [reqPoolLimit, setReqPoolLimit] = useState(5)
  const [pgTransactionData, setPgTransactionData] = useState(null)
  const amountRegex = /^\d+(\.\d)?\d*$/

  const { goBack } = useNavigation()

  const redirectToBillPayment = () => {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: Routes.BILL_PAYMENTS } as never],
      }),
    )
  }

  useEffect(() => {
    if (pgTxnState === 'pending') {
      setIsLoading(true)
    } else if (pgTxnState === 'fulfilled') {
      if (pgTxnData?.status === 'completed') {
        setIsRedirectingToPg(false)
        setPgPaymentSuccess(true)
        setTxnCheckStatus(TRANSACTION_PENDING)
        setPgTransactionData(pgTxnData)
      }
    } else if (pgTxnState === 'rejected') {
      updateTransaction({ status: 'FAILED' })
      if (pgTxnData?.message?.includes('canceled by user')) {
        setIsLoading(false)
        setIsRedirectingToPg(false)
        RootStore?.response?.setCustomToast({
          message: pgTxnData?.message ?? 'Something went wrong. Please try again later',
          position: ToastPosition.BOTTOM,
          toastType: ToastType.POSITIVE,
        })
      } else {
        navigation.dispatch(
          CommonActions.reset({
            index: 0,
            routes: [{ name: Routes.BILL_PAYMENTS_DETAILS, params: { data: paymentStatusData } } as never],
          }),
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pgTxnState])

  useEffect(() => {
    if (paymentStatusState === 'fulfilled') {
      if (paymentStatusData?.status === 'RECHECK') {
        updateTransaction({ status: TRANSACTION_PENDING })
        setTxnCheckStatus(TRANSACTION_PENDING)
      } else {
        // setIsLoading(false)
        setReqPoolLimit(0) //finish the req pool api call
        updateTransaction({ status: paymentStatusData?.status })
        setTxnCheckStatus('SUCCESS')
        // navigate to success screen
        navigation.dispatch(
          CommonActions.reset({
            index: 0,
            routes: [{ name: Routes.BILL_PAYMENTS_DETAILS, params: { data: paymentStatusData } } as never],
          }),
        )
      }
    } else if (paymentStatusState === 'rejected') {
      // take to payment pending screen if the payment is still in progress
      console.log('paymentStatusState rejected ===> ', paymentStatusState, paymentStatusData)
      if (paymentStatusData?.status === 'PENDING' || paymentStatusData?.status === 'RECHECK') {
        setTxnCheckStatus(TRANSACTION_PENDING)
        updateTransaction({ status: TRANSACTION_PENDING })
        // request timeout take to pending details
        if (reqPoolLimit === 0) {
          setIsLoading(false)
          navigation.dispatch(
            CommonActions.reset({
              index: 0,
              routes: [{ name: Routes.BILL_PAYMENTS_DETAILS, params: { data: paymentStatusData } } as never],
            }),
          )
        }
      } else if (paymentStatusData?.status === 'FAILURE') {
        updateTransaction({ status: 'FAILED' })
        setReqPoolLimit(0)
        setIsLoading(false)
        navigation.dispatch(
          CommonActions.reset({
            index: 0,
            routes: [{ name: Routes.BILL_PAYMENTS_DETAILS, params: { data: paymentStatusData } } as never],
          }),
        )
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentStatusState])

  useEffect(() => {
    if (createOrderLoading === 'fulfilled') {
      callbackFn(createOrderData)
    } else if (createOrderLoading === 'rejected') {
      setIsLoading(false)
      redirectToBillPayment()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createOrderLoading])

  const callbackFn = useCallback(
    (data: any) => {
      const { pgMetaData } = data ?? {}
      setIsLoading(true)
      redirectToPgView(pgMetaData)
    },
    [redirectToPgView],
  )

  useInterval(() => {
    if (pgPaymentSuccess && pgTransactionData && reqPoolLimit > 0) {
      // call check status api
      setTxnCheckStatus(TRANSACTION_PENDING)
      checkPaymentStatusApi(pgTransactionData?.response?.orderId)
      setReqPoolLimit(reqPoolLimit - 1)
    } else {
      setTxnCheckStatus('')
      //setIsLoading(false)
    }
  }, 5000)

  const getDisplayData = (bill: any) => {
    const listData = []
    const billAmount = bill?.amount && bill?.amount !== '' ? parseFloat(bill?.amount) : 0
    const agentFeeAmount = bill?.agentFeeAmount ? parseFloat(bill?.agentFeeAmount) : 0
    let total: number = billAmount + agentFeeAmount
    const basicBillInfo = {
      'Consumer Name': bill?.customerName,
      'Bill Amount': `₹ ${bill?.amount ? bill?.amount : 0}`,
      'Agent Fee Amount': bill?.agentFeeAmount ? `+ ₹ ${bill?.agentFeeAmount}` : 'NA', // included in extra info object
      'Total Amount': `₹ ${total.toFixed(2)}`,
      'Bill Number': bill?.billNumber,
      'Bill Date': bill?.date,
      'Due Date': bill?.dueDate,
      'Bill Period': bill?.period,
      'Bill Payment Date': bill?.billPaymentDate,
      'Bill Payment Txn Ref No': bill?.lastTxnRefNo,
      'Bill Scheduled Debit Date': bill?.billPaymentDate,
      'Bill Amount After Due Date': bill?.amountAfterDueDate,
    }

    listData.push(
      ...Object.entries(basicBillInfo)
        .filter((item) => item[1] && item[1] !== 'NA')
        .map((item) => {
          return {
            label: item[0],
            value: item[1],
          }
        }),
    )

    if (bill?.extraInfos) {
      const extraInfoArray = bill?.extraInfos
        .filter(
          (extraInfo: ExtraInfos) =>
            extraInfo?.value &&
            extraInfo?.value !== 'NA' &&
            extraInfo?.value !== '' &&
            extraInfo.name !== 'Bill Amount' &&
            extraInfo.name !== 'Agent Fee Amount' &&
            extraInfo.name !== 'Total Amount',
        )
        .map((extraInfo: ExtraInfoProps) => {
          return { label: extraInfo.name, value: extraInfo.value }
        })
      if (extraInfoArray.length > 0) {
        listData.splice(1, 0, ...extraInfoArray)
      }
    }
    // store customer name and first authendicators lable and value to display at txn status screen
    const dataStore = {
      'Consumer Name': bill?.customerName?.toUpperCase() ?? 'NA',
      'Consumer Number': bill?.authenticators[0] ?? 'NA',
      'Product Name': operator?.name,
    }
    storeData('dataStore', dataStore)
    const stored = getFromStore('dataStore')
    //localStorage.setItem('dataStore', JSON.stringify(dataStore))
    return listData
  }

  const billData = getDisplayData(bill)

  const validateAmount = (amt: any) => {
    const min = operator?.minAmount
    const max = operator?.maxAmount
    const enteredAmount = parseFloat(amt) //TODO: entered amount
    const notAllowed = (!operator?.partialPaymentAllow && amt === 0) || bill?.alertFlag
    if (notAllowed) {
      goBack()
      return false
    }

    // validate the amount
    if (!amountRegex.test(amt)) {
      setMessage('Invalid amount', 'NEGATIVE', false, '', 'TOP')
      return false
    } else if (enteredAmount < min) {
      setMessage(`Amount should be more than Rs. ${min}`)
      return false
    } else if (enteredAmount > max) {
      setMessage(`Amount should be less than Rs. ${max}`)
      return false
    } else if (partialPaymentType === 'EXACT' && enteredAmount !== billAmount) {
      setMessage(`Amount should be exactly Rs. ${billAmount}`)
      return false
    } else if (partialPaymentType === 'EXACT_UP' && enteredAmount < billAmount) {
      setMessage(`Amount should be more than Rs. ${billAmount}`)
      return false
    } else if (partialPaymentType === 'EXACT_DOWN' && enteredAmount > billAmount) {
      setMessage(`Amount should be less than Rs. ${billAmount}`)
      return false
    } else if (enteredAmount >= min && enteredAmount <= max) {
      if (amt?.split('.')?.length <= 2) {
        if (enteredAmount?.[1]?.length > 2) {
          setMessage('Invalid amount entered')
          return false
        } else {
          return true
        }
      }
    }
  }

  const onProceedToPay = (values: any) => {
    setIsRedirectingToPg(true)
    setIsLoading(true)
    updateTransaction({ amount: amount })
    createOrderApi(amount, values)
  }

  const onChangeAmount = (enteredAmount: any) => {
    if (/[a-zA-Z]/.test(enteredAmount)) {
      //setAmount(amount)
    } else if (enteredAmount?.length === 0) {
      setAmount('')
    } else {
      setAmount(enteredAmount)
    }
  }

  const rightComponent = (
    <Box pl={10} pr={20}>
      {/* <Text fontFamily="JioType-Medium" fontSize={12} color={'#FC6770' as ColorOptions}>
        Due in 2 Days
      </Text> */}
    </Box>
  )
  const leftComponent = (
    <Box pl={20} mt={5}>
      <Text fontFamily="JioType-Bold" lineHeight={24} fontSize={24} color={Colors.BLACK_14 as ColorOptions}>
        ₹
      </Text>
    </Box>
  )

  const billAmountInput = () => (
    <>
      <ModBox>
        <Text fontFamily="JioType-Medium" fontSize={12} lineHeight={16} color={Colors.PRIMARY_GREY as ColorOptions}>
          Payable Amount
        </Text>
        <Spacer size={10} direction="vertical" />
        <Box bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions} borderRadius={8} align="center">
          <TextInput
            minHeight={45}
            bottomLineColor={'TRANSPARENT'}
            onFocusBottomLineColor={'TRANSPARENT'}
            value={amount}
            // bgColor={convertHexToRGBA('#000', 80) as ColorOptions}
            color={Colors.BLACK_14 as ColorOptions}
            editable={partialPaymentAllow && partialPaymentType !== 'EXACT'}
            // paddingHorizontal={10}
            rightComponent={rightComponent}
            leftComponent={leftComponent}
            onChangeText={onChangeAmount}
            fontFamily={'JioType-Black'}
            // fontWeight={'900'}
            fontSize={24}
            maxLength={14}
            lineHeight={28}
            onBlur={() => {
              if (partialPaymentAllow && partialPaymentType !== 'EXACT') {
                validateAmount(amount)
              }
            }}
          />
        </Box>
      </ModBox>
      <Spacer size={30} direction="vertical" />
      <Text fontFamily="JioType-Bold" lineHeight={20} fontSize={14} color={Colors.BLACK_14 as ColorOptions}>
        Bill Details
      </Text>
      <Spacer size={10} direction="vertical" />
    </>
  )

  const renderActionButtons = ({ isCurrentFormValid, values }: ActionButtonProps) => {
    return (
      <Button
        disabled={!isCurrentFormValid || isLoading}
        height={50}
        isFull
        isLoading={isLoading}
        isRound
        testID="btn-proceed-pay"
        onPress={() => {
          //setIsLoading(true)
          if (validateAmount(amount)) {
            onProceedToPay(values)
          }
        }}>
        <Text color="WHITE" fontSize={16} fontFamily="JioType-Bold">
          Proceed to Pay ₹ {amount}
        </Text>
      </Button>
    )
  }

  const testNavigation = () => {
    checkPaymentStatusApi('987654123456')
    //navigation.navigate(Routes.BILL_PAYMENTS_DETAILS as never)
  }

  return (
    <Box flex={1} backgroundColor="SECONDARY" position={'relative'} pt={70}>
      <ModBox {...styles.listWrapper} backgroundColor={'WHITE'} p={0}>
        <ModBox
          flexDirection={'row'}
          align="center"
          justify="space-between"
          show={operator?.name?.length}
          bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
          p={25}>
          <Box align="center" justify="center" flexDirection={'row'}>
            <Box width={40} justifyContent="center" alignContent="center">
              <Logo logo={operator?.logoPath ?? ''} type="medium" />
            </Box>
            <Box marginHorizontal={10}>
              <Text
                fontSize={12}
                color={Colors.PRIMARY_GREY as ColorOptions}
                fontFamily="JioType-Medium"
                lineHeight={16}>
                {operator?.name}
              </Text>
              <ModBox show={bill?.authenticators[0]?.length}>
                <Text fontSize={14} color={Colors.BLACK_14 as ColorOptions} fontFamily="JioType-Medium" lineHeight={20}>
                  {bill?.authenticators[0]?.toUpperCase()}
                </Text>
              </ModBox>
            </Box>
          </Box>

          <Box
            align="center"
            justify="center"
            //alignSelf={'flex-end'}
            onPress={() => navigation?.goBack()}
            testID="change-biller"
            underlayColor="TRANSPARENT">
            <Text fontFamily="JioType-Medium" fontSize={14} color="PRIMARY" lineHeight={20}>
              Change
            </Text>
          </Box>
        </ModBox>
        <ScrollView contentContainerStyle={{ flexGrow: 1 }} nestedScrollEnabled={true}>
          <Box f={1} justifyContent="space-between" flexDirection={'column'} backgroundColor="WHITE" overflowY={'auto'}>
            <Box ph={25} pt={20}>
              <Spacer size={10} direction="vertical" />
              <FlatList
                testID="billFetchView"
                nestedScrollEnabled={false}
                data={showMore ? billData : billData?.slice(0, 3)}
                //data={billData}
                keyboardDismissMode="on-drag"
                keyboardShouldPersistTaps={'handled'}
                contentInset={{ bottom: 8, top: 8 }}
                //contentContainerStyle={styles.billDetailsContainer}
                showsVerticalScrollIndicator={false}
                renderItem={BillItem}
                keyExtractor={(item) => item.value}
                extraData={showMore}
                ListHeaderComponent={billAmountInput()}
              />
              <ModBox
                show={billData?.length > 3}
                pt={15}
                testID="showMore"
                onPress={() => setShowMore(!showMore)}
                underlayColor={'TRANSPARENT'}>
                <Text fontFamily="JioType-Medium" fontSize={14} color="PRIMARY">
                  {showMore ? 'View Less' : 'Show More'}
                </Text>
              </ModBox>
            </Box>
          </Box>
        </ScrollView>
        <Box pt={15}>
          <Box {...styles.proceedBtn}>
            <Button
              //isLoading={isLoading}
              height={50}
              disabled={!amountRegex.test(amount)}
              type="primary"
              testID="btn-proceed-to-pay"
              onPress={() => {
                // testNavigation()
                if (isOsMobile() && Keyboard.isVisible()) {
                  Keyboard.dismiss()
                }
                if (validateAmount(amount)) {
                  setShowModal(true)
                  setTimeout(() => {
                    InteractionManager.runAfterInteractions(() => {
                      mobileNumberRef?.current?.focus()
                    })
                  }, 500)
                }
              }}
              isRound
              isFull={true}
              underlayColor={'PRIMARY'}>
              <Text fontFamily="JioType-Bold" fontSize={16} color={'WHITE'}>
                Proceed
              </Text>
            </Button>
          </Box>
          <SpacerNew size={10} direction="vertical" />
          <Box backgroundColor={convertHexToRGBA('#000', 3) as ColorOptions}>
            <PoweredBy />
          </Box>
        </Box>
      </ModBox>

      {/* Payment loader modal */}
      <ModalDialogNew
        onBackPress={() => {
          if (isLoading) {
            setMessage('Please wait your transaction is processing.')
          } else {
            setShowModal(false)
          }
        }}
        animate={true}
        type="bottom"
        show={showModal}
        backgroundColor={'TRANSPARENT'}>
        <Box {...styles.modalContainer} minHeight={isLoading ? height - 120 : 200}>
          <ModBox
            // show={txnCheckStatus === TRANSACTION_PENDING && reqPoolLimit > 0}
            show={isLoading && reqPoolLimit > 0}
            minHeight={isLoading ? height - 120 : 200}
            align="center"
            justify="center">
            <Box maxWidth={'80%'} align="center" justify="center">
              <LottieLoader />
              <Spacer size={24} direction="vertical" />
              <Text {...styles.loaderText}>
                {isRedirectingToPg
                  ? 'Redirecting to payment gateway'
                  : 'Redirecting you back to our app. Thank you for your payment!'}
              </Text>
            </Box>
          </ModBox>
          <ModBox
            // show={txnCheckStatus !== TRANSACTION_PENDING}
            show={!isLoading}
            testID="modal-CustomerDetails"
            minHeight={200}>
            <Box flexDirection={'row'}>
              <Box w={'80%'}>
                <Text {...styles.headerText}>Customer Details</Text>
              </Box>
              <Box
                flex={1}
                alignItems="flex-end"
                pt={8}
                onPress={() => {
                  setShowModal(false)
                }}
                testID="cancel-modal"
                underlayColor="TRANSPARENT">
                <SvgImage width={24} height={24} imageName="Close" />
              </Box>
            </Box>

            <KeyboardAwareScrollView
              showsVerticalScrollIndicator={false}
              keyboardDismissMode="interactive"
              keyboardShouldPersistTaps="handled"
              enableOnAndroid={true}>
              <Spacer size={30} />
              <Form
                initialValues={{ mobileNumber: '', modeOfPayment: '' }}
                formData={getFormData(mobileNumberRef)}
                container={DefaultFormContainer}
                actionButtons={renderActionButtons}
                ref={formRef}
              />
            </KeyboardAwareScrollView>
            <Spacer size={30} />
          </ModBox>
        </Box>
      </ModalDialogNew>
    </Box>
  )
}

const styles = {
  modalContainer: {
    pt: 25,
    ph: 25,
    overflow: 'auto',
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    backgroundColor: 'WHITE',
  } as BoxProps,
  listWrapper: {
    flex: 1,
    backgroundColor: 'WHITE',
    padding: 25,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    width: '100%',
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
  billDetailsContainer: {
    //...shadow,
    marginHorizontal: 16,
    marginVertical: 16,
    // padding: 16,
    // borderColor: '#EFEFEF',
    // backgroundColor: '#fff',
    // borderWidth: 1,
    // paddingBottom: 12,
    flexDirection: 'column',
  } as ViewStyle,
  amountBox: {
    //...shadow,
    margin: 16,
    padding: 16,
    bg: 'WHITE',
    borderRadius: 5,
  } as BoxProps,
  proceedBtn: {
    padding: 16,
    bg: 'WHITE',
    justifyContent: 'center',
    alignItems: 'flex-end',
  } as BoxProps,
  headerText: {
    fontSize: 24,
    fontFamily: 'JioType-Black',
    color: 'BLACK_21',
    lineHeight: 28,
  } as TextProps,
  loaderText: {
    fontSize: 14,
    fontFamily: 'JioType-Medium',
    color: 'BLACK_21',
    textAlign: 'center',
    lineHeight: 20,
  } as TextProps,
}

const leftComponent = (
  <Text title={'+91'} fontFamily={'JioType-Medium'} fontSize={16} color={Colors.BLACK_14 as ColorOptions} />
)

const getFormData = (mobileNumberRef: any) => {
  const initialFormData = [
    {
      key: 'customer details',
      formItems: [
        {
          fieldName: 'mobileNumber',
          ComponentName: TextInputWithLabelOnBorder,
          height: 48,
          fontSize: 16,
          labelFontSize: 14,
          leftComponent: leftComponent,
          testID: 't-mobile',
          accessibilityLabel: 't-mobile',
          validationSchema: mobileNumber,
          maxLength: 10,
          inputMode: 'numeric',
          label: 'Customer Mobile Number',
          fontFamily: 'JioType-Medium',
          innerRef: mobileNumberRef,
          selectionColor: Colors.PRIMARY,
        },
        {
          fieldName: 'spacer1',
          ComponentName: Spacer,
          direction: 'vertical',
          size: 20,
        },
        {
          fieldName: 'label1',
          ComponentName: InfoText,
          title: "A confirmation SMS will be sent to the customer's mobile number.",
          color: Colors.PRIMARY_GREY as ColorOptions,
          fontFamily: 'JioType-Medium',
          fontSize: 12,
        },
        {
          fieldName: 'modeOfPayment',
          ComponentName: ModeOfPayment,
          validationSchema: required,
        },
        {
          fieldName: 'spacer2',
          ComponentName: Spacer,
          direction: 'vertical',
          size: 20,
        },
      ],
      verticalSpacing: 0,
      onSubmit: () => {
        return 'end'
      },
    },
  ]
  return initialFormData
}

export default BillFetch
